var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 5C1.875 4.65482 2.15482 4.375 2.5 4.375H17.5C17.8452 4.375 18.125 4.65482 18.125 5C18.125 5.34518 17.8452 5.625 17.5 5.625H2.5C2.15482 5.625 1.875 5.34518 1.875 5Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20833 10C5.20833 9.65482 5.48816 9.375 5.83333 9.375L14.1667 9.375C14.5118 9.375 14.7917 9.65482 14.7917 10C14.7917 10.3452 14.5118 10.625 14.1667 10.625L5.83333 10.625C5.48816 10.625 5.20833 10.3452 5.20833 10Z",
    fill: "#656579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54167 15C8.54167 14.6548 8.82149 14.375 9.16667 14.375L10.8333 14.375C11.1785 14.375 11.4583 14.6548 11.4583 15C11.4583 15.3452 11.1785 15.625 10.8333 15.625L9.16667 15.625C8.82149 15.625 8.54167 15.3452 8.54167 15Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterList);
export default __webpack_public_path__ + "static/media/filter-list.c01a2cd2933c794fd474cc8052ebf0fd.svg";
export { ForwardRef as ReactComponent };